import React from "react";
import AppVersion from "./AppVersion";

const AppFooter = () => {
  return (
    <footer className="tw:flex tw:items-center tw:justify-between tw:gap-2 tw:px-4 tw:py-3 tw:text-xs tw:text-text-muted tw:lg:px-6">
      <div className="tw:text-[10px] tw:text-text-muted">
        MBLAB <span className="tw:ms-1">&copy; 2024.</span>
      </div>
      <div className="tw:ms-auto">
        <AppVersion />
      </div>
    </footer>
  );
};

export default React.memo(AppFooter);
